import React from 'react';
import Header from './Header';
import OverallProgress from './OverallProgress';
import StudentsTable from './StudentsTable';

const ClassroomCharacterReport: React.FC = () => {
  return (
    <>
      <Header />
      <OverallProgress />
      <StudentsTable />
    </>
  );
};

export default ClassroomCharacterReport;
